import img from "../../../../assets/point-guide/step2_Houbi_ KOR3.png";
export default function Huobi3() {
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src={img} style={{ width: "100%", maxWidth: "800px", height: "auto", marginBottom: "-0.5px" }} alt={""} />
        </div>
    );
}
